import React from 'react'
import { connect } from 'react-redux'
// import { createSelector } from 'reselect'

const Warning = ({ visible, required }) =>
	visible ? (
		<div
			style={{
				backgroundColor: '#d5922b',
				color: '#fff',
				borderRadius: 35,
				padding: 12,
				fontSize: 18,
			}}
		>
			{required ? 'This field is required. ' : ''}If a field either hidden or
			read only, a contact will not be able to fill out this field manually.
			Some coding will be needed.
		</div>
	) : null

export default connect((state, { sectionID, type = 'field' }) => {
	const fieldOrContactField =
		state.customForm.addOrEdit.sectionsByID[sectionID][type]

	const required = fieldOrContactField.required

	const visible = fieldOrContactField.hidden || fieldOrContactField.readonly

	return { visible, required }
}, null)(Warning)
